export * from "../typography";
export * from "./theme";
export type { Theme } from "./types";

export const APP_WIDTH = 1440;
export const APP_GUTTER = 70;
